import { render, staticRenderFns } from "./courses_form.vue?vue&type=template&id=1d1e3e41&"
import script from "./courses_form.vue?vue&type=script&lang=js&"
export * from "./courses_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports